angular.module('ui2.0Directives').directive('projectModal',['$http','$rootScope','aeService','$location','$timeout',function(http,rootScope,aeService,$location,$timeout){
    return {
        restrict :'AE',
        templateUrl: rootScope.createHtmlUrl("ui2.0/extraction/projectPopup.html"),
        link: function(scope,elm,attrs){
            scope.projectData = {
                // id:2,
                name:"",
                description:"",
                // default: false,
                projectLinkedFieldIds:[],
                projectLinkedCategories:[]
            };
            scope.viewMode = "create";
            if(attrs.viewMode=="show" || attrs.viewMode=="edit"){
                scope.projectData.id=attrs.viewId;
                scope.viewMode = attrs.viewMode;
            }
            scope.searchText = {value:""};
            scope.searchCategory = {value:""};
            scope.searchClause = {value:""};
            scope.allChecked = {value:false};
            scope.allCategoryChecked = {value:false};
            scope.allClauseChecked = {value:false};
            scope.allFields = [];
            scope.allCategories = [];
            scope.projectData.supplier = rootScope.entityListIdNameMap[3] ? "Suppliers" : null;;
            scope.allClause = [];
            scope.isUpdateAllowed = true;
            scope.updateAllowedToast='';
            scope.fieldErrors = {
                nameError: false,
                isNameDirty: false,
                noLinkError: false,
                isLinkDirty: false
            };
            scope.visibleFields = [];
            scope.visibleCategories = [];
            scope.visibleClause=[];
            scope.projectData.hasSupplierPermission = scope.projectData.supplier && !scope.projectData.id
            // scope.isAEProjectId=6;

            scope.sectionInfo = {
                sectionState: {},
                sectionLabels: [
                    {name:"openFields", label: "Fields"},
                    {name:"openClause", label: "Clauses"},
                    {name:"openCategory", label: "Base Clauses"},
                ],
                showSectionLabels: {},
                selectCategoryLabel: "Clause - Base Text",
                baseClauseTextLabel: "Base Text",
                selectClauseLabel: "Clause - Category",
                clauseTextLabel: "Selected Clauses",
            }
            ;(function () {
                _.forEach(scope.sectionInfo.sectionLabels,obj => {
                    scope.sectionInfo.showSectionLabels[obj.name] = true;
                })
                if( !scope.aeProjectClauseDeviationBaseText ) {
                    $timeout(() =>{
                        $(".base_clause").hide()
                    })
                }
            })();

            scope.toggleSectionState = function(valToToggle){
                scope.sectionInfo.sectionState[valToToggle]= !scope.sectionInfo.sectionState[valToToggle];

                _.forEach(scope.sectionInfo.showSectionLabels,(value,key) => {
                    if(scope.sectionInfo.sectionState[valToToggle]) {
                        if(key != valToToggle) {
                            scope.sectionInfo.showSectionLabels[key] = false;
                        }
                    }else {
                        scope.sectionInfo.showSectionLabels[key] = true;
                    }
                })
            }

            scope.isBaseClauseEmpty = (data) => {
                if(data) {
                    let emptyBaseClauseElm = _.find(data,elm => !elm.baseClauseText.trim());
                    return emptyBaseClauseElm ? true : false;
                }
                return false;
            }

            scope.getAllFields = function(flag){
                var endpoint = "/metadataautoextraction/getAllFields";
                http.get(endpoint).then(function(res){
                    scope.allFields = res.data.response;
                    if(flag){
                        scope.allFields.map(function(el){
                            if(scope.projectData.projectLinkedFieldIds) {
                                if (scope.projectData.projectLinkedFieldIds.indexOf(el.id) != -1) {
                                    el.selected = true;
                                }
                            }
                            return el;
                        })
                        $timeout(function(){
                            scope.allChecked.value = scope.isAllSelected(scope.visibleFields);
                        })
                    }
                })
            }

            if(scope.projectData.id){
                var endpoint = "/metadataautoextraction/show?projectId="+scope.projectData.id + "&_t="+new Date().getTime();
                http.get(endpoint).then(function(res){
                    scope.projectData.projectLinkedCategories= _.get(res,"data.response.projectLinkedCategories") || [];
                    scope.allCategories = _.get(res,"data.response.allApplicableCategories") || [];
                    scope.isUpdateAllowed = res.data.response.isUpdateAllowed;
                    scope.updateAllowedToast = res.data.response.updateAllowedToast;
                    scope.modifyAllCategories(scope.allCategories);
                    scope.projectData.name = res.data.response.name;
                    scope.projectData.description= res.data.response.description;
                    scope.projectData.projectLinkedFieldIds= res.data.response.projectLinkedFieldIds;
                    scope.projectData.linkedCategoryIds = res.data.response.linkedCategoryIds;
                    scope.allClause = angular.copy(scope.allCategories);
                    const aeProjectDescriptionIFrame = document.getElementById("aeProjectDescription");
                    if(!!aeProjectDescriptionIFrame) {
                        aeProjectDescriptionIFrame.contentDocument.body.innerHTML = res.data.response.description;
                    }
                    scope.modifyAllClause();
                    scope.getAllFields(true);
                })
            }else {
                scope.getAllFields();
                aeService.getApplicableCategory({onlyResponse:true}).then(res => {
                        scope.allCategories = res || [];
                        scope.modifyAllCategories(scope.allCategories);
                        scope.allClause = angular.copy(scope.allCategories);
                        scope.modifyAllClause();
                })
            }
            scope.modifyAllClause = function () {
                scope.allClause = scope.allClause.map(function(el){
                    if(scope.projectData.linkedCategoryIds){
                        if (scope.projectData.linkedCategoryIds.indexOf(el.id) != -1) {
                            el.selected = true;
                        }
                    }else{
                        el.selected = true;
                    }
                    return el;
                })
                $timeout(function(){
                    scope.allClauseChecked.value = scope.isAllSelected(scope.visibleClause);
                })
            }

            scope.modifyAllCategories = (data) => {
                data && _.forEach(data,val=>{
                    const savedElement = _.find(scope.projectData.projectLinkedCategories,elm => elm.id == val.id);
                    val.baseClauseText = _.get(savedElement,"baseClauseText") || '';
                    val.selected = savedElement ? true : false;
                })
            }

            scope.actOnAll = function(flag,type){
                if(type === 'openFields'){
                if(flag)
                    scope.fieldErrors.noLinkError = true;
                else
                    scope.fieldErrors.noLinkError = false;scope.allChecked.value =flag;
                scope.visibleFields.map(function(elm){
                    elm.selected=flag;
                    return elm;
                })}else if(type === 'openCategory') {
                    scope.allCategoryChecked.value =flag;
                    scope.visibleCategories.map(function(elm){
                        elm.selected=flag;
                        if(!flag) elm.baseClauseText = '';
                        return elm;
                    })
                }else if(type === 'openClause') {
                    scope.allClauseChecked.value =flag;
                    scope.visibleClause.map(function(elm){
                        elm.selected=flag;
                        return elm;
                    })
                }
            }

            scope.toggleField = function(){
                scope.allChecked.value=scope.isAllSelected(scope.visibleFields);
            }
            scope.supplierCbSelected = function() {
                if (scope.projectData.supplierCheckbox) {
                    scope.projectData.name = "Supplier name will be replicated"
                } else {
                    scope.projectData.name = "";
                }
            }
            scope.toggleCategory = function(fld){
                scope.allCategoryChecked.value=scope.isAllSelected(scope.visibleCategories);
                if(fld && !fld.selected) fld.baseClauseText = '';
            }
            scope.toggleClause = function (){
                scope.allClauseChecked.value = scope.isAllSelected(scope.visibleClause);
            }

            scope.searchChanged = function(type){
                if(type === 'openFields') {
                    if(!scope.visibleFields.length) {
                        scope.allChecked.value = false;
                        return;
                    }
                    scope.allChecked.value =scope.isAllSelected(scope.visibleFields);
                }else if(type === 'openClause') {
                    if(!scope.visibleClause.length) {
                        scope.allClauseChecked.value = false;
                        return;
                    }
                    scope.allClauseChecked.value = scope.isAllSelected(scope.visibleClause);
                }else if(type === 'openCategory') {
                    if(!scope.visibleCategories.length) {
                        scope.allCategoryChecked.value = false;
                        return;
                    }
                    scope.allCategoryChecked.value =scope.isAllSelected(scope.visibleCategories);
                }
            }

            scope.isAllSelected = function(data){
                var obj = aeService.isAll(data, "selected",true);
                if(obj.linkNotEmpty) {
                    scope.fieldErrors.noLinkError = true;
                } else{
                    scope.fieldErrors.noLinkError = false;
                }
                return obj.retval;
            }
            scope.isNoneSelected = function(data){
                return aeService.isNone(data,"selected",true);
            }

            function getAddedFields(){
                var sel = scope.allFields.filter(function(elm){return elm.selected});
                return sel.map(function(el){return el.id});
            }
            function getAddedCategoriesId(){
                var clause = scope.allClause.filter(function(elm){return elm.selected});
                var baseClause = scope.allCategories.filter(function(elm){return elm.selected});
                var finalArray = clause.concat(baseClause);
                var retVal = finalArray.map(function(el){return el.id});
                return [...new Set(retVal)];
            }

            scope.nameChangeHandler = function () {
                if(scope.fieldErrors.nameError)
                    scope.fieldErrors.nameError = false;
            };

            function getAddedCategories(){
                const sel = scope.allCategories.filter(function(elm){return elm.selected});

                let valueToReturn =  sel.map(elm => {
                    const  {id,name,baseClauseText} = elm;
                    return {
                        id,
                        name,
                        baseClauseText
                    }
                });
                return _.isEmpty(valueToReturn) ? [] : valueToReturn;
            }

            scope.removeSelectedCategory = (category) => {
                if(category) {
                    category.selected = false;
                    category.baseClauseText = '';
                }
            }

            scope.createProject = function() {
                scope.fieldErrors.isLinkDirty = true;
                scope.fieldErrors.isNameDirty = true;
                if (!scope.projectData.name) {
                    //alertDialog(intl_msg[29447]);
                    return;
                }
                obj = scope.projectData;
                obj.projectLinkedFieldIds = getAddedFields();
                obj.linkedCategoryIds = getAddedCategoriesId();
                scope.projectData.isClauseAndFieldEmpty = (!obj.projectLinkedFieldIds.length && !obj.linkedCategoryIds.length)
                if(scope.aeProjectClauseDeviationBaseText && !obj.supplierCheckbox) {
                    obj.projectLinkedCategories = getAddedCategories();
                    if(scope.isBaseClauseEmpty(obj.projectLinkedCategories)) {
                        Toaster.create("Please fill base text for all selected categories");
                        return ;
                    }
                }
                startLoader()
                let bulkProjectCreate = (obj.supplierCheckbox && !scope.projectData.id)
                let payload = null;
                let header = null;
                if(bulkProjectCreate){
                    payload = new FormData();
                    header = { headers: { "Content-Type": undefined}}
                    payload.append("replicateSupplier", obj.supplierCheckbox);
                    payload.append("linkedCategoryIds", obj.linkedCategoryIds);
                    payload.append("projectLinkedFieldIds", obj.projectLinkedFieldIds);
                } else {
                    payload = JSON.stringify(obj);
                    header = "";
                }

                var endpoint = bulkProjectCreate ? "/auto-extraction/v3/upload/project" : "/metadataautoextraction/create";


                obj.clientId = clientId;
                if(scope.projectData.id){
                    endpoint = "/metadataautoextraction/update";
                }
                http.post(endpoint, payload, header).then(function (res) {
                    stopLoader()
                    const args = {
                        popupType: 'alert',
                        heading: intl_msg[24153]
                    }
                    if (res.data.success) {
                        rootScope.aeDocPropMasterData = null;
                        scope.projectPopupInstance.close();
                        if(!scope.projectData.id) {
                            obj.supplierCheckbox ? Toaster.create(res.data.response) : "";
                            $("table#cr").dataTable().fnDraw();
                        }else{
                            rootScope.refreshUpdateParam();
                        }
                    } else if(res.data.responseCode == "422") {
                            scope.fieldErrors.nameError = res.data.response;
                    }else if(res.data.errors && res.data.errors.length){
                        args.str = res.data.errors[0].message;
                        SirionUtils.openSirionDialogs(args);
                    }else if( typeof res.data.response == 'string'){
                        args.str = res.data.response;
                        SirionUtils.openSirionDialogs(args);
                    }
                })
            }
        }
    }
}])

angular.module('ui2.0Directives').directive('aeDocProp',["$rootScope","$http","aeService","filterService","$q",function(rootScope,http,aeService,filterService,$q){
    return {
        restrict: 'AE',
        templateUrl:  rootScope.createHtmlUrl("ui2.0/extraction/aeDocProp.html"),
        link: function(scope,elm,attrs){
            filterService.setMsSettings.call(scope);
            if(! scope.docPropData){
                scope.docPropData = {};
            }
            scope.projectMultiSelectEvent = {
                onSelectionChanged:function(e){
                    if(_.has(scope.docPropData, "projects.values") && scope.docPropData.projects.values.length  > 0 && angular.element("#jx-propProject").find(".multiselect-parent").hasClass("errorClass") > -1 ){
                        angular.element("#jx-propProject").find(".multiselect-parent").removeClass("errorClass");
                    }
                }
            }
            scope.aedata = true;
            scope.docPropData.projects = {values:[],options:[]}
            scope.docPropData.groups = {values:[],options:[]};
            scope.docPropData.doctags = {values:[],options:[]};
            scope.docPropData.tag1 = {values:[],options:[]};
            scope.docPropData.tag2 = {values:[],options:[]};

            if(!rootScope.aeDocPropMasterData){
                var apiUrl = "/autoextraction/masterData";
                http.get(apiUrl).then(function (response) {
                    rootScope.aeDocPropMasterData=response.data;
                    aeService.populateMasterPropertyData.call(scope);
                });
            }else{
                aeService.populateMasterPropertyData.call(scope);
            }
            aeService.populateDocumentPropertyData.call(scope);

            scope.addGroup = function(val){
                aeService.addNewProp(val,'2','groups', scope);
            }
            scope.addTag = function(val){
                aeService.addNewProp(val,'3','tags',scope);
            }
            scope.addTag1 = function(val){
                aeService.addNewProp(val,'4','tag1',scope);
            }
            scope.addTag2 = function(val){
                aeService.addNewProp(val,'5','tag2',scope);
            }
            scope.updateDocProps = function() {
                if (_.has(scope.docPropData, "projects.values") && scope.docPropData.projects.values.id) {
                    angular.element("#jx-propProject").find(".multiselect-parent").removeClass("errorClass");
                    var postObj = {
                        contractDocumentId: scope.docPropData.docId,
                        projectIds: aeService.extractIdsOnly([scope.docPropData.projects.values]),
                        groupIds: aeService.extractIdsOnly(scope.docPropData.groups.values),
                        tagIds: aeService.extractIdsOnly(scope.docPropData.doctags.values),
                        tag1: aeService.extractIdsOnly(scope.docPropData.tag1.values),
                        tag2: aeService.extractIdsOnly(scope.docPropData.tag2.values)
                    }
                    var endpoint = '/autoextraction/updateProperties';
                    var postObj2 = {
                        docIds: [Number(scope.docPropData.docId)],
                        projectId: scope.docPropData.projects.values.id,
                    }
                    var endpoint2 = '/autoextraction/moveAEDocumentProject';
                    var projectId = this.projectId;
                    var pId = projectId.split(";");
                    var sc = $('.field').scope();
                    var currentProjectId = sc.docPropData.projects.values.id;
                    var promise=[];
                    promise.push(http.post(endpoint,postObj));
                    if(currentProjectId != pId[1]){
                        promise.push(http.post(endpoint2,postObj2))
                    }
                    startLoader();
                    $q.all(promise).then(function (res) {
                        stopLoader();
                        $('#cr').dataTable().fnDraw();
                        scope.removePropContainer();
                        if(res[1].data.responseCode == 200 ){
                            Toaster.create(res[1].data.response)
                        }
                        else{
                            Toaster.create(res[1].data.errors[0].message)
                        }
                    }, function (err) {
                        toggleServerErrorNotification(true);
                        stopLoader();
                    })
                }else{
                    angular.element("#jx-propProject").addClass("errorClass")
                }
            }
            scope.deleteDoc = function(){
                const args = {
                    popupType: 'confirm',
                    str: intl_msg[29343],
                    heading: intl_msg[25772],
                    yesCbFn: function(){
                        var Obj = {
                            docIds: [Number(scope.docPropData.docId)],
                        }
                        var url = '/autoextraction/deleteAEDocuments';
                        startLoader();
                        http.post(url,Obj).then(function(res){
                            stopLoader();
                            if(res.data.responseCode == 200){
                                Toaster.create(res.data.response)
                                scope.reloadListing();
                            }
                            else{
                                Toaster.create(res.data.errors[0].message)
                            }
                        }, function(err){
                            toggleServerErrorNotification(true);
                            stopLoader();
                        })
                    },
                    noCbFn: function(){
                        return false;
                    }
                }
                SirionUtils.openSirionDialogs(args);
            }

        }
    }
}])

angular.module('ui2.0Directives').directive('globalDocUpload', ["$rootScope", "$http", "breadcrumbService", '$timeout','aeService',function(rootScope, http, breadcrumbService, timeout, aeService) {
    return {
        restrict: 'AE',
        link: function (scope, elm, attrs) {

            scope.aeService = aeService;
            scope.folderUpload = false;
            scope.batchSize = 10;
            scope.filesUploadedCount = 0;
            scope.duplicateAllowed = false;
            scope.MDClausePorting = {
                'value':false,
            }
            scope.ObligationPorting = {
                'value':false,
            }

            var fileList = [];

            function uploadFiles(reqUrl, fd, headers, tempObj, elm, stopLoaderFlag) {
                http.post(reqUrl, fd, {
                    transformRequest: angular.identity,
                    headers: headers
                }).then(function (response) {
                    stopLoader();
                    scope.uploadedFileCount ++;
                    if((scope.uploadedFileCount % scope.batchSize == 0 || scope.totalFiles == scope.fileList.length ) && scope.folderUpload){
                        var filesToUpload = Object.entries(scope.files).slice(scope.filesUploadedCount, scope.filesUploadedCount + scope.batchSize).map(entry => entry[1]);
                        scope.filesUploadedCount += scope.batchSize;
                        scope.sendUploadCalls(filesToUpload, elm);
                    }
                    if (response.status == 200 || response.status == 201) {
                        scope.successfulFileCount++;
                        scope.findAndUpdateFile(tempObj.key, scope.treeDOM, response.data.documentDetails.documentId)
                        if (scope.drsEnabled) {
                            tempObj['key'] = response.data.documentDetails.documentId;
                            tempObj['noOfPages'] = response.data.noOfPages;
                            tempObj['fileSize'] = response.data.fileSize;
                        }
                        scope.fileList.push(tempObj);
                        scope.batchListForFinalUpdate.push(tempObj);
                        scope.setFileStatus(scope.treeDOM, tempObj.key, 'uploaded')
                        if (stopLoaderFlag && !scope.folderUpload) {
                            stopLoader();
                        }
                        if ((scope.uploadedFileCount % 5 == 0 || scope.totalFiles == scope.fileList.length + scope.failedFiles.length) && scope.folderUpload) {
                            var filesToUpdate = scope.fileList.slice(scope.filesUpdateCount, scope.filesUpdateCount + 5);
                            scope.filesUpdateCount += filesToUpdate.length;
                        }
                    } else if (response.status != 200) {
                        scope.failedFiles.push(tempObj);
                        scope.setFileStatus(scope.treeDOM, tempObj.key, 'failed')
                        if (scope.totalFiles == scope.fileList.length + scope.failedFiles.length) {
                            var filesToUpdate = scope.fileList.slice(scope.filesUpdateCount, scope.filesUpdateCount + 5);
                            scope.filesUpdateCount += filesToUpdate.length;
                        }
                        let errorMsg = _.get(response, "data.message") || response?.statusText || '';
                        if (response.status === 403) {
                            errorMsg = _.get(response, "data.message") || intl_msg[49213] || 'You do not have permission to perform any of these actions. Please contact your administrator.';
                        }
                        Toaster.create(errorMsg, {iconClass: "icon-Information_filled"});
                    } else {
                        SirionUtils.openSirionDialogs({
                            popupType: 'alert',
                            str: intl_msg[23500],
                            heading: "NOTIFICATION"
                        });
                    }
                });
            }

            scope.sendUploadCalls = function(fileList, element){
                var sequence = Promise.resolve();
                angular.forEach(fileList, function (item) {
                    item["id"] = Math.ceil(Math.random() * 1000);
                    sequence = sequence.then(function () {
                        scope.totalFilesUploaded++;
                        var stopLoaderFlag = (scope.totalFilesUploaded == scope.totalFiles) ? true : false;

                        return scope.uploadDocFiles(item, element, stopLoaderFlag);
                    })
                });
            }

            scope.removeDuplicateFiles = function(element, _fileList, callBack) {
                let firstIdx = Object.keys(_fileList)[0];
                let project = _fileList[firstIdx].webkitRelativePath.split("/")[0];
                var projectIds = '';
                if(scope.docPropData.projects.values.id){
                    projectIds = scope.docPropData.projects.values.id;
                } else {
                    projectIds = scope.docPropData.projects.values.map(item => {
                        return item.id
                    });
                }
                let apiUrl = `/v3/auto-extraction/projects/${projectIds}/paths/${project}?_t=${new Date().getTime()}`;

                http.get(apiUrl).then(function (response) {
                    let fileNames = Object.values(_fileList).map((f)=>(f.webkitRelativePath).toLowerCase());
                    response.data = response.data.map((f)=>(f.relativePath+"/"+f.name).toLowerCase());

                    let commonFiles = _.intersection(fileNames, response.data);
                    _fileList = Object.values(_fileList).filter((f)=> !commonFiles.includes((f.webkitRelativePath).toLowerCase()));
                    if(!_fileList.length){
                        Toaster.create('All files are found duplicate. Nothing was uploaded!');
                        return;
                    }
                    if(callBack)
                        var fileList = aeService.getAllowedFilesOnly(_fileList);
                        callBack(fileList, element, _fileList);
                });
            }

            scope.handleFiles = function(fileList, element, _fileList) {
                var notAllowedFileExtns = [];
                if(scope._fileList && Object.keys(scope._fileList).length && scope.folderUpload){
                    var currentLength =  Object.keys(scope._fileList).length;
                    var lastKey = Object.keys(scope._fileList)[currentLength-1]
                    Object.keys(fileList).forEach((file)=>{
                        scope._fileList[++lastKey] = fileList[file];
                    })
                } else{
                    scope._fileList = fileList;
                }
                var _fileListArr = Object.keys(_fileList).map((file)=>_fileList[file].name); // Array of allowed type files
                var fileListArr = Object.keys(scope._fileList).map((file)=>scope._fileList[file].name); //Array of not allowed type files
                notAllowedFileExtns = [...new Set(_.difference(_fileListArr, fileListArr).map((file)=>file.split(".")[file.split(".").length-1].toLowerCase()))];
                if(notAllowedFileExtns.length){ //User uploaded some files of not allowed extensions
                    Toaster.create(aeService.aeLabels.notAllowed.replace("%s",notAllowedFileExtns.join(', ') ),{iconClass:"icon-Information_filled"});
                }

                scope.totalFiles = Object.keys(scope._fileList).length;
                if(!scope.folderUpload && fileList && scope.totalFiles){
                    startLoader();
                }
                if(scope.folderUpload){
                    scope.treeDOM = aeService.manageFolderStructure(fileList);
                }
                scope.totalFilesUploaded = 0;
                var filesToUpload = scope.files = fileList;
                if(scope.folderUpload){
                    filesToUpload =Object.entries(scope.files).slice(scope.filesUploadedCount, scope.filesUploadedCount + scope.batchSize).map(entry => entry[1]);
                    scope.filesUploadedCount += scope.batchSize;
                }
                scope.sendUploadCalls(filesToUpload, element);
                element.value = "";
            }

            scope.uploadExtractionFile = function (element, droppedFilesList) {
                scope.element = element;
                scope.allowFileUpload = true;
                scope.batchListForFinalUpdate = [];
                var _fileList = droppedFilesList != undefined ? droppedFilesList : element.files;
                if( Object.keys(_fileList).length) {
                    if (scope.folderUpload && !scope.duplicateAllowed) {
                        fileList = scope.removeDuplicateFiles(element, _fileList, scope.handleFiles);
                    } else {
                        var fileList = aeService.getAllowedFilesOnly(_fileList);
                        scope.handleFiles(fileList, element, _fileList);
                    }
                }
            };

            scope.getUploadedFilesDetails = (treeNodeList) => {
                const flatList = [];
                let uploadCount =0;
                const traverse = (treeDOM) => {
                    if(treeDOM.isAFolder)
                        _.forEach(treeDOM.children,node => traverse(node));
                    else {
                        flatList.push(treeDOM);
                        uploadCount += (treeDOM.uploaded ? 1 : 0);
                    }
                }
                if(Array.isArray(treeNodeList))
                    _.forEach(treeNodeList,node => traverse(node));
                else traverse(treeNodeList);
                return {
                    files:flatList,
                    uploadCount
                };
            }

            scope.getAccessToken = function(){
                let url = addtStamp("/v1/authHelper/getAccessToken");
                return http.get(url);
            }

            scope.getSuccessfulFileCount = () => {
                const details = scope.getUploadedFilesDetails(scope.treeDOM);
                return details.uploadCount;
            }

            scope.uploadDocFiles = function (file, elm, stopLoaderFlag) {
                scope.getAccessToken().then(res => {
                    window.sessionStorage.setItem('accessToken', res.data.token);
                    var fd = new FormData();
                    let sFileName = file.name;
                    let arrayOfNamesSplitted = sFileName.split('.');
                    arrayOfNamesSplitted.splice((arrayOfNamesSplitted.length - 1), 1);
                    let sFileNameWithoutExt = escapeHtml(arrayOfNamesSplitted.join("."));
                    const reverseCharMap = {"&amp;": "&","&quot;": '"',"&#39;": "'"};
                    sFileNameWithoutExt = window.unescapeHtml(sFileNameWithoutExt,reverseCharMap); // Safe for database storage
                    let sFileExtension = sFileName.split('.')[sFileName.split('.').length - 1].toLowerCase();
                    let validExtensions = aeService.getAllowedExtensions();
                    let reqUrl = '/file/upload';
                    let drsObject = sessionStorage.getItem('drsObject');
                    const headers = {};
                    if (validExtensions.indexOf(sFileExtension) > -1) {
                        if (scope.drsEnabled) {
                            drsObject = JSON.parse(drsObject);
                            let Url = drsObject.drsUrl;
                            if (Url) {
                                Url += "/v1/upload"
                                headers['Authorization'] = sessionStorage.getItem("accessToken");
                                reqUrl= Url
                            }
                            fd.append("multipartFile", file)
                            fd.append("envDetail", drsObject.sirionEnvDetails)
                            fd.append("clientId", window.clientId);
                        } else {
                            fd.append("documentFileData", file);
                            fd.append("key", file.key);
                        }
                        fd.append("name", sFileNameWithoutExt);
                        fd.append("extension", sFileExtension);

                        const tempObj = {
                            extension: sFileExtension,
                            key: file.key,
                            name: sFileNameWithoutExt
                        }

                        if (file.webkitRelativePath) {
                            tempObj.relativePath = file.webkitRelativePath.split("/").slice(0, -1).join("/")
                        }

                        if (scope.allowFileUpload) {    
                            headers["Content-Type"] = undefined;
                            if(window.sessionStorage.getItem('drsPathBasedRouting') === 'false'){
                                headers['Authorization'] = sessionStorage.getItem("accessToken");
                            }
                            uploadFiles(reqUrl, fd, headers, tempObj, elm, stopLoaderFlag);
                        }
                    } else {
                        SirionUtils.openSirionDialogs({
                            popupType: 'alert',
                            str: intl_msg['6431'],
                            heading: "NOTIFICATION"
                        });
                        stopLoader();
                    }
                })
            };
            scope.triggerFileInput = function (index) {
                angular.element('.aeGlobalUpload').val('');
                if(index === 0)
                    scope.folderUpload = false;
                if(index == 1){
                    if(aeService.getAllowedExtensions().length == 0){
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: aeService.aeLabels.selectFileType, heading: "NOTIFICATION"});
                        return;
                    }
                    if(scope.folderUpload && scope.treeDOM.length){
                        scope.folderUpload = true;
                        const args = {
                            popupType: 'confirm',
                            str: aeService.aeLabels.folderOverWrite,
                            heading: intl_msg[25772],
                            yesCbFn: function () {
                                scope.initializeVariables();
                                angular.element('.aeGlobalUpload')[index].click();
                            },
                            noCbFn: function () {
                            }
                        }
                        SirionUtils.openSirionDialogs(args);
                    } else{
                        scope.folderUpload = true;
                        scope.initializeVariables();
                        angular.element('.aeGlobalUpload')[index].click();
                    }
                } else{
                    angular.element('.aeGlobalUpload')[index].click();
                }
            };
            scope.removeFile = function (file,folderUpload) {
                if(!folderUpload) {
                    const index = scope.fileList.indexOf(file);
                    scope.fileList.splice(index, 1);
                }else{
                    // Remove from failed files list if exist
                    _.remove(scope.failedFiles,f => file.key == f.key);

                    scope.findAndRemoveFile(scope.treeDOM[0].children,file,false,scope.treeDOM);
                    scope.totalFiles--;
                }
            }

            scope.removeFiles = function (files) {

                let fileObjArray = files.map(file =>{
                    return scope.fileList.find((f)=>{
                        return file.key == f.key
                    });
                });
                let uploadedFiles = fileObjArray.filter(fileObj => {
                    return scope.filesKeyIdMap.hasOwnProperty(fileObj.key)
                });

                if(!_.isEmpty(uploadedFiles)){
                    var endPoint = "/autoextraction/api/v1/document/delete";
                    var payload = {
                        'docIds' : uploadedFiles.map(f => scope.filesKeyIdMap[f.key])
                    };
                    http.post(endPoint, payload);
                }

            }

            scope.toggleAllowedType = function(e,type){
                e.stopPropagation();
                type.allowed = !type.allowed;
            }
            scope.findAndRemoveFile = function(_tree, file, stop,parent){
                _tree.forEach((tree,index)=>{
                    if( (!tree.isAFolder && tree.path == file.path) || (tree.isAFolder && tree.name == file.name) ){
                        _tree.splice(index,1);
                        if(!_tree.length){
                            scope.findAndRemoveFile(scope.treeDOM,parent,false);
                        }
                        scope.fileList = scope.fileList.filter((f)=>{
                            return f.key != file.key
                        });
                    } else {
                        if(tree.children.length){
                            scope.findAndRemoveFile(tree.children,file,stop,tree);
                        }
                    }
                })
            }
            scope.stopFileUpload = function(){
                scope.allowFileUpload = false;
            }

            scope.updateDocuments = function (postData,promiseResolve) {
                if (postData.length > 0 ) {
                    const reqUrl = "/v3/auto-extraction/documents/update";
                    var projectIds = '';
                    if(scope.docPropData.projects.values.id){
                        projectIds = scope.docPropData.projects.values.id;
                    } else {
                        projectIds = scope.docPropData.projects.values.map(item => {
                            return item.id
                        });
                    }
                    const groupIds = scope.docPropData.groups.values.map(item => {
                        return item.id
                    });
                    const tagIds = scope.docPropData.doctags.values.map(item => {
                        return item.id
                    });
                    projectIds = [].concat(projectIds);
                    if(projectIds && projectIds.length) {
                        angular.forEach(postData, function (value, key) {
                            value['projectIds'] = projectIds;
                            value['groupIds'] = groupIds;
                            value['tagIds'] = tagIds;
                            value['portMDAndClauses'] = scope.MDClausePorting.value;
                            value['portObligation'] = scope.ObligationPorting.value;
                        })
                        rootScope.pendingDocUpdateCalls += 1;
                        http.post(reqUrl, postData).then(function (response) {
                            if (_.has(response, "data.errors") && response.data.errors == null) {
                                rootScope.pendingDocUpdateCalls -= 1;
                                if(rootScope.pendingDocUpdateCalls == 0)
                                    promiseResolve && promiseResolve(true);
                            }
                        });
                    }
                }
            }

            scope.initializeVariables = function(){
                scope.uploadedFileCount = 0;
                scope.filesUploadedCount = 0;
                scope.totalFiles = 0;
                scope.filesUpdateCount = 0;
                scope.successfulFileCount = 0;
                scope.filesKeyIdMap = {};
                rootScope.pendingDocUpdateCalls = 0;
                scope._fileList = {};
                scope.fileList = [];
                scope.treeDOM = [];
                scope.failedFiles = [];
            }
            scope.initializeVariables();

            scope.retryFailedFiles = function(){

                let newFileSet = [];
                Object.values(scope.files).forEach((f)=>{
                    let file = scope.failedFiles.find((_f)=>{
                        return f.key == _f.key;
                    });
                    file ? newFileSet.push(f) : '';
                })
                scope.files = newFileSet;
                scope.failedFiles = [];
                scope.filesUploadedCount = 0;
                var filesToUpload = Object.entries(scope.files).slice(scope.filesUploadedCount, scope.filesUploadedCount + scope.batchSize).map(entry => entry[1]);

                scope.filesUploadedCount += scope.batchSize;
                scope.sendUploadCalls(filesToUpload, scope.element);
            }
            scope.setFileStatus = function(_tree, key, state){
                _tree.forEach((tree,index)=>{
                    if( !tree.isAFolder && tree.key && tree.key == key){
                        if(state == 'failed'){
                            tree['uploaded'] = false;
                        } else if(state == 'uploaded'){
                            tree['failed'] = false;
                        }
                        tree[state] = true;
                        return;
                    } else {
                        if(tree.children.length){
                            scope.setFileStatus(tree.children,key,state);
                        }
                    }
                })
            }
            scope.findAndUpdateFile = function(fileKey,treeObj, drsKey){
                treeObj.forEach(function(file){
                    if(!file.isAFolder && file.key == fileKey){
                        file.key = drsKey;
                    } else if( file.children.length){
                        scope.findAndUpdateFile(fileKey,file.children,drsKey);
                    }
                })
            }
            var deleteFolder = rootScope.$on('delete folder',function (e) {
                if(scope.folderUpload){
                    scope.removeFiles(scope.fileList);
                }
            })
            scope.$on('$destroy', function() {
                deleteFolder();
                delete rootScope.pendingDocUpdateCalls;
            });

        }
    }
}])
angular.module('ui2.0Directives').directive('aeRandomiser',["$rootScope","$http","aeService","filterService","entityFactory",function(rootScope,http,aeService,filterService,entityFactory){
    return {
        restrict: 'AE',
        templateUrl:  rootScope.createHtmlUrl("ui2.0/extraction/aeRandomiser.html"),
        link: function(scope,elm,attrs){
            scope.tagOptions = [];
            scope.tagType = {};
            scope.missingRandomSize = false;
            scope.missingRandomDd = false;
            scope.sizeLimitExceeded = false;
            scope.invalidSize = false;
            scope.docPropData = {
                projects : {},
                groups : {},
                doctags : {},
                tag1: {},
                tag2: {}
            };
            rootScope.aeDocPropMasterData = {
                tags : [],
                projects : [],
                statuses : [],
                groups : [],
                tag1   : [],
                tag2 : []
            }

            scope.initDirective = function(){
                startLoader();
                var apiUrl = "/autoextraction/masterData";
                http.get(apiUrl).then(function (response) {
                    stopLoader();
                    rootScope.aeDocPropMasterData.tag1 = response.data.tag1;
                    rootScope.aeDocPropMasterData.tag2 = response.data.tag2;
                    scope.tagOptions.push(
                        {
                            name    : intl_msg[31072] ? intl_msg[31072] : 'QC Level-1',
                            type    : 'tag1',
                            options :  response.data.tag1,
                            values  :   []
                        },
                        {
                            name    :   intl_msg[31073] ? intl_msg[31073] : 'QC Level-2',
                            type    :   'tag2',
                            options :   response.data.tag2,
                            values  :   []
                        });
                    scope.tagType = scope.tagOptions[0];
                    scope.tag1 = {
                        options : response.data.tag1,
                        values  :   []
                    }
                    scope.tag2 = {
                        options : response.data.tag2,
                        values  :   []
                    }
                });
            }
            scope.initDirective();
            scope.submitAeRadomiserData = function(){
                scope.missingRandomSize = scope.missingRandomDd =  scope.sizeLimitExceeded = scope.invalidSize = scope.tagError = scope.sizeError =false;
                let tagName = scope.tagType.type;
                if(!scope.tagType.values.length && !scope.size){
                    scope.tagError = true;
                    scope.sizeError = true;
                    return;
                }
                if(scope.tagType.values.length && !scope.size){
                    scope.missingRandomSize = true;
                    scope.sizeError = true;
                    return;
                }
                if(!scope.tagType.values.length && scope.size){
                    scope.missingRandomDd = true;
                    scope.tagError = true;
                    return;
                }
                if(!rootScope.allSelected && scope.size && parseInt(scope.size) > checkedVal.length){
                    scope.sizeLimitExceeded = true;
                    return;
                }
                if(scope.size && (isNaN(scope.size) || scope.size <=0)){
                    scope.invalidSize = true;
                    return;
                }
                var payload = {
                    randomDocuments : {
                        tag1 : [],
                        tag2 : [],
                        size : scope.size ? parseInt(scope.size) : ''
                    },
                    allDocuments : {
                        tag1 : mapToCommaSepIds(scope.tag1.values),
                        tag2 : mapToCommaSepIds(scope.tag2.values)
                    },
                    documentIds : checkedVal
                }
                if(!aeService.allRowsSelected(payload,scope)){
                    payload.documentIds = checkedVal
                }
                payload.randomDocuments[tagName] = mapToCommaSepIds(scope.tagType.values);
                entityFactory.getReactFilterData(payload);
                http.post('/autoextraction/bulkUpdate/tag1Andtag2',JSON.stringify(payload)).then((response)=>{
                    if (response.data.success) {
                        Toaster.create('Your request has been completed successfully',{iconClass:"icon-Information_filled"});
                    }
                    scope.openAERandomizerModal.close();
                })
            }


            var mapToCommaSepIds = function(values){
                return values.map( (v) =>{
                    return v.id;
                });
            }
            scope.addTag1 = function(val){
                aeService.addNewProp(val,'4','tag1',scope);
            }
            scope.addTag2 = function(val){
                aeService.addNewProp(val,'5','tag2',scope);
            }
            scope.clearTagValues = function(tagType) {
                let indexToClear = tagType.type == 'tag1' ? 1 : 0;
                scope.tagOptions[indexToClear].values = [];
            }
        }
    }
}])
angular.module('ui2.0Directives').directive('aeAssignForReview',["$rootScope","$http","aeService","filterService", "entityFactory",function(rootScope,http,aeService,filterService, entityFactory){
    return {
        restrict: 'AE',
        templateUrl:  rootScope.createHtmlUrl("ui2.0/aeAssignForReview.html"),
        link: function($scope,elm,attrs){
            $scope.initDirective = function(){
                $scope.aedata ={'aeBulkDownload' : true ,'selectedStakeHolder' :[] ,'selectedCheckBox':[] ,'entityTypeId':367 ,
                    'totalStakeholder' : [] , 'tempValueStakeHolder': []};
                if(checkedVal && checkedVal.length){
                    $scope.aedata.selectedCheckBox = [...checkedVal];
                }
                startLoader();
                http({
                    dataType: "json",
                    contentType: "application/json;charset=UTF-8",
                    method: 'GET',
                    url: appName + "/autoextraction/v1/stakeholder/316",
                    async: false
                }).then(function (res) {
                    if(res && res.data && res.data.length>0){
                        $scope.aedata.totalStakeholder = res.data;
                        $scope.aedata['tempValue'] =[];
                    }if((res && !res.data) || (res && res.data && res.data.length==0) ){
                        SirionUtils.openSirionDialogs({popupType: 'alert', str: 'Please configure document workflow.', heading: intl_msg[24153],yesCbFn: "closeAeModal",yesName: "OK"});
                    }
                    stopLoader();
                });
            };
            $scope.initDirective();
            $scope.sendForDownload =function(){
                $scope.aedata['error'] = false;
                var requestObjAe= {};
                requestObjAe['entityTypeId'] =316;
                requestObjAe['stakeHolders'] = [];
                if(!aeService.allRowsSelected(requestObjAe,$scope)){
                    requestObjAe['entityIds']= [... $scope.aedata.selectedCheckBox];
                }
                if($scope.aedata.selectedStakeHolder && $scope.aedata.selectedStakeHolder.length){
                    var copyStakeHolder =JSON.parse(JSON.stringify($scope.aedata.selectedStakeHolder));
                    for(var i =0;i<$scope.aedata.selectedStakeHolder.length;i++){
                        var obj ={};
                        obj['roleGroupId'] =$scope.aedata.selectedStakeHolder[i].roleGroupId;
                        obj['userIds'] =[];
                        obj['userGroupIds'] =[];
                        if(copyStakeHolder && copyStakeHolder.length){
                            for(var j = 0;j<copyStakeHolder.length;j++){
                                if(obj['roleGroupId'] == copyStakeHolder[j].roleGroupId){
                                    if(copyStakeHolder[j].group){
                                        obj['userGroupIds'].push(copyStakeHolder[j].id);
                                    }else{
                                        obj['userIds'].push(copyStakeHolder[j].id);
                                    }
                                }
                            }
                            copyStakeHolder = copyStakeHolder.filter(eachobj =>{
                                if(eachobj.roleGroupId!=obj.roleGroupId){
                                    return eachobj;
                                }
                            });
                        }
                        if(obj.roleGroupId && obj.userGroupIds.length >0 || obj.userIds.length >0){
                            requestObjAe['stakeHolders'].push(obj);
                        }
                    }
                }
                var sendRequest =false;
                if(requestObjAe.stakeHolders && requestObjAe.stakeHolders.length && $scope.aedata.totalStakeholder.length == requestObjAe.stakeHolders.length ){
                    sendRequest =true
                }else{
                    sendRequest =false;
                }
                entityFactory.getReactFilterData(requestObjAe);
                if($scope.aedata.selectedStakeHolder && $scope.aedata.selectedStakeHolder && sendRequest){
                    startLoader();
                    http({
                        dataType: "json",
                        data: requestObjAe,
                        contentType: "application/json;charset=UTF-8",
                        method: 'POST',
                        url: appName + "/autoextraction/v1/moveEntity/workflow",
                        async: false
                    }).then(function (res) {
                            var message ='';
                            if(res  && res.data.status && res.data.status == 'Success' && res.data.Message){
                                message = res.data.Message;
                            }
                            if(res && res.data && res.data.status == 'Error' && res.data.Message && res.data.Message.length){
                                message = res.data.Message[0].errorMessage;
                            }
                            stopLoader();
                            $scope.closeAeModal();
                            $scope.deselectAllSelections();
                            if(message && message!=''){
                                Toaster.create(message,{iconClass:"icon-Information_filled"});
                                $scope.reloadListing();
                            }

                        },
                        function (result, errorThrown) {
                        });
                }
                else {
                    $scope.aedata['error']=true;
                    $scope.aedata['errorMsg'] = 'All stakeholders should filled before moving to workflow.'
                }
            }
            $scope.setAeDownloadStakeHolder=function(stakeholder,removeFlag ,roleGroupId){
                if(removeFlag && stakeholder && $scope.aedata){
                    var copyStakeHolder =JSON.parse(JSON.stringify($scope.aedata.selectedStakeHolder));
                    $scope.aedata.selectedStakeHolder.filter((everyStakeHolder,index)=>{
                        if(everyStakeHolder.id ==stakeholder && everyStakeHolder.roleGroupId == roleGroupId){
                            copyStakeHolder.splice(index,1);
                        }
                    });
                    $scope.aedata.selectedStakeHolder =copyStakeHolder;
                }
                if(!removeFlag && stakeholder){
                    var aeAddFlag= true;
                    if(aeAddFlag){
                        $scope.aedata.selectedStakeHolder.push(stakeholder);
                        if ($scope.aedata.selectedStakeHolder.length == $scope.aedata.totalStakeholder.length ){
                            $scope.aedata['error'] =false;
                        }
                    }
                }
            }
            $scope.closeAeModal = function(){
                delete $scope.aedata;
                $scope.aeDownloadModal.close()
            }
        }
    }
}])

angular.module('ui2.0Directives').directive('featureInfoBanner',["$rootScope","$http","aeService","filterService",function(rootScope,http,aeService,filterService){
    return {
        restrict: 'AE',
        templateUrl:  rootScope.createHtmlUrl("ui2.0/featureInfoBanner.html"),
        link: function(scope,elm,attrs){
            scope.infoDetailes = [];
            scope.hideErrorListDiv = false;
            let featureId = $(elm).closest('[show-info-banner]').attr('feature-id');
            http.get(addtStamp('/autoextraction/getRequestStatus/'+featureId, true)).then(function(res){
                scope.infoDetailes = res.data;
            })
            scope.togglePropValue = function (val, propVal) {
                if(propVal){
                    scope[val] = propVal;
                } else{
                    scope[val] = !scope[val];
                }
            }
        }
    }
}])

angular.module('ui2.0Directives').directive('extractedMetaData',["$rootScope","$http","aeService",function(rootScope,http,aeService){
    return {
        restrict: 'AE',
        templateUrl:  rootScope.createHtmlUrl("ui2.0/extraction/extractedMetaData.html"),
        link: function(scope,elm,attrs){
            scope.headerLabel = {
                "433": "Metadata",
                "493": "Clause",
                "437" : "Obligation"
            }
            scope.showMetadataPopup = false;
            scope.ACTION_TYPE = {
                INSERT: 1,
                UPDATE:2,
                DELETE:3
            }

            scope.fields = [];
            scope.defValue ={
                label:'--Select--',
            }
            scope.popupMetaData = {
                selectedField: {},
                updatedValue:''
            };
            scope.itemMetaData = scope.document[parseInt(attrs.itemDataIndex)];
            scope.cancelMetadataHandler = () => {
                scope.showMetadataPopup = false;
                scope.popupMetaData.updatedValue = '';
                scope.popupMetaData.selectedField = {};
            }
            scope.openMetaDataPopup = () => {
                event.stopPropagation();
                if(!scope.showMetadataPopup) {
                    scope.showMetadataPopup = true;
                    aeService.getFieldCategoryMapping(scope,scope.itemMetaData.categoryId);
                }
            }

            scope.submitMetaData = (actionType) => {
                if(!_.get(scope.popupMetaData,"selectedField.id") || !scope.popupMetaData.updatedValue.trim())
                    return;
                let attrs = {
                    scope,
                    itemData:scope.itemMetaData,
                    popupData: scope.popupMetaData,
                    actionType:actionType
                }
                aeService.createUpdateDeleteMetadata(attrs)
            }
        }
    }
}])

angular.module('ui2.0Directives').directive('addNewClause',["$rootScope","$http","aeService",function(rootScope,http,aeService){
    return {
        restrict: 'AE',
        templateUrl:  rootScope.createHtmlUrl("ui2.0/extraction/addNewClause.html"),
        link: function(scope,elm,attrs){
            scope.headerLabel = {
                "433": "Metadata",
                "493": "Clause",
                "437" : "Obligation"
            }
            scope.pageNoError = false;
            scope.maxPageCount = 0;
            scope.showNewClausePopup = false;
            scope.popUpData = {
                applicableCategories:[],
                newCategory: {},
                pageNo:'',
                newText:'',
                coordinates:'',
                score: 1
            };
            scope.cancelNewClauseHandler = () => {
                scope.showNewClausePopup = false;
                scope.popUpData.pageNo = '';
                scope.popUpData.newText = '';
                scope.popUpData.coordinates = '';
                scope.popUpData.score = 1;
                scope.popUpData.newCategory = {};
            }
            scope.openNewClausePopup = () => {
                scope.maxPageCount = scope.getMaxPageCount();
                event.stopPropagation();
                if(!scope.showNewClausePopup) {
                    scope.showNewClausePopup = true;
                    aeService.getApplicableCategory({scope});
                }
            }

            scope.getMaxPageCount = () => {
                let iframe = document.getElementsByClassName('iframe_contract_template')[0];
                if(iframe)
                    return iframe.contentWindow.getMaxPageCount();
                return 0;
            }

            scope.submitNewClauseData = (actionType) => {
                if(!_.get(scope.popUpData,"newCategory.id") || !scope.popUpData.newText || !scope.popUpData.pageNo)
                    return;
                if(!scope.maxPageCount) {
                    scope.maxPageCount = scope.getMaxPageCount();
                }
                if(scope.popUpData.pageNo > scope.maxPageCount) {
                    SirionUtils.openSirionDialogs({popupType: 'alert', str: "Entered page no exceeds max page count : "+scope.maxPageCount, heading: "NOTIFICATION"});
                    return;
                }
                let attrs = {
                    scope,
                    popupData: scope.popUpData,
                    actionType
                }
                aeService.createUpdateClauses(attrs)
            }

            scope.pageNoCheck = (event) => {
                var currValue = scope.popUpData.pageNo ? scope.popUpData.pageNo.toString() : '' ;

                if(currValue.search(/[^0-9]/) != -1) {
                    scope.pageNoError = true;
                    setTimeout(()=>{
                        scope.pageNoError = false;
                    },1000)
                }

                $(event.currentTarget).val(currValue.replace(/[^0-9]/, ''));
            }
        }
    }
}])
angular.module('ui2.0Directives').directive('deviationScoreInfo',["$rootScope","$http","aeService",function(rootScope,http,aeService){
    return {
        restrict: 'AE',
        templateUrl:  rootScope.createHtmlUrl("ui2.0/extraction/deviationScoreInfo.html"),
        link: function(scope,elm,attrs){
            scope.headerLabel = {
                "433": "Metadata",
                "493": "Clause",
                "437" : "Obligation"
            }

            scope.showDeviationPopup = false;
            scope.deviationInfo = "";
            scope.noData = false;

            scope.closeDeviationScorePopup = () => {
                scope.showDeviationPopup = false;
                scope.deviationInfo =""
            }
            scope.openDeviationScorePopup = () => {
                if(!scope.showDeviationPopup) {
                    scope.noData = false;
                    scope.showDeviationPopup = true;
                    const _attrs = {
                        scope,
                        textId: attrs.textId
                    }
                    if(_attrs.textId) {
                        aeService.getInfoTextForDeviationScore(_attrs).then(res => {
                            if(_.get(res,"data")) {
                                scope.deviationInfo = res.data;
                                scope.$apply();
                            }else {
                                scope.noData = true;
                            }
                        })
                    }else {
                        scope.noData = true;
                    }
                }
            }
        }
    }
}])

angular.module('ui2.0Directives').directive('partialDocumentmodal',['$http','$rootScope','aeService','$location','$timeout',function(http,rootScope,aeService,$location,$timeout){
    return {
        restrict :'AE',
        templateUrl: rootScope.createHtmlUrl("ui2.0/extraction/partialDocument.html"),
        link: function(scope,elm,attrs){
            scope.searchText = {value:""};
            scope.searchCategory = {value:""};
            scope.searchClause = {value:""};
            scope.allChecked = {value:true};
            scope.allCategoryChecked = {value:true};
            scope.fieldErrors = {
                nameError: false,
                isNameDirty: false,
                noLinkError: false,
                isLinkDirty: false
            };
            scope.visibleFields = [];
            scope.visibleCategories = [];
            scope.visibleClause=[];
            scope.portToGeneral = {"value" : false};
            scope.overWrite = {"value" :false};

            scope.sectionInfo = {
                sectionState: {},
                sectionLabels: [
                    {name:"openFields", label: "Fields"},
                    {name:"openCategory", label: "Category"},
                ],
                showSectionLabels: {}
            };
            (function () {
                _.forEach(scope.sectionInfo.sectionLabels,obj => {
                        scope.sectionInfo.showSectionLabels[obj.name] = true;
            })
            })();

            scope.toggleSectionState = function(valToToggle){
                scope.sectionInfo.sectionState[valToToggle]= !scope.sectionInfo.sectionState[valToToggle];

                _.forEach(scope.sectionInfo.showSectionLabels,(value,key) => {
                    if(scope.sectionInfo.sectionState[valToToggle]) {
                        if(key != valToToggle) {
                            scope.sectionInfo.showSectionLabels[key] = false;
                        }
                    } else {
                        scope.sectionInfo.showSectionLabels[key] = true;
                    }
                })
            }
            scope.showSection = function(label){
                if(label == 'Fields'){
                    return scope.allFields.length;
                } else if (label == 'Category'){
                    return scope.allCategory.length;
                }
            }

            scope.actOnAll = function(flag,type){
                if(type === 'openFields'){
                    if(flag)
                        scope.fieldErrors.noLinkError = true;
                    else
                        scope.fieldErrors.noLinkError = false;
                        scope.allChecked.value =flag;
                        scope.visibleFields.map(function(elm){
                        elm.selected=flag;
                        return elm;
                    })}
                    else if(type === 'openCategory') {
                        scope.allCategoryChecked.value =flag;
                        scope.visibleCategories.map(function(elm){
                            elm.selected=flag;
                            return elm;
                        })
                    }
            }

            scope.toggleField = function(){
                scope.allChecked.value=scope.isAllSelected(scope.visibleFields);
            }
            scope.toggleCategory = function(){
                scope.allCategoryChecked.value=scope.isAllSelected(scope.visibleCategories);
            }
            scope.searchChanged = function(type){
                if(type === 'openFields') {
                    if(!scope.visibleFields.length) {
                        scope.allChecked.value = false;
                        return;
                    }
                    scope.allChecked.value =scope.isAllSelected(scope.visibleFields);
                }else if(type === 'openCategory') {
                    if(!scope.visibleCategories.length) {
                        scope.allCategoryChecked.value = false;
                        return;
                    }
                    scope.allCategoryChecked.value =scope.isAllSelected(scope.visibleCategories);
                }
            }

            scope.isAllSelected = function(data){
                var obj = aeService.isAll(data, "selected",true);
                if(obj.linkNotEmpty) {
                    scope.fieldErrors.noLinkError = true;
                } else{
                    scope.fieldErrors.noLinkError = false;
                }
                return obj.retval;
            }
            scope.isNoneSelected = function(data){
                return aeService.isNone(data,"selected",true);
            }

            function getAddedFields(){
                var sel = scope.allFields.filter(function(elm){return elm.selected});
                return sel.map(function(el){return el.id});
            }
            function getAddedCategoriesId(){
                var sel = scope.allCategory.filter(function(elm){return elm.selected});
                return sel.map(function(el){return el.id});
            }

            scope.partPortDocumentSubmit = function() {
                startLoader();
                var fId = getAddedFields();
                var cId = getAddedCategoriesId();
                let obj = {};
                if (scope.partialDoc) {
                    let endpoint = "/autoextraction/doPartialPorting";
                    obj = {
                        "portMDAndClauses": true,
                        "portObligations": false,
                        "fieldIds":fId,
                        "categoryIds":cId,
                        "overwrite": scope.overWrite.value,
                        "portToGeneralTab": scope.portToGeneral.value
                    };
                    const { selectAll, entityIds } = BU.buildPayload();
                    obj.selectAll = selectAll;
                    if(selectAll){
                        obj['documentIds'] = [];
                        let filteredData = stringify_datatable_json(filterDataJson);
                        if(window.reactFilterLoaded && !_.isEmpty(window.payload)) {
                            dataSend = JSON.parse(filteredData);
                            dataSend.filterMap.filterJson = window.payload && window.payload.filterMap &&  window.payload.filterMap.filterJson;
                            if($(".nextState").length>0 && dataSend.filterMap.filterJson && $(".nextState").val()!=''){
                                dataSend.filterMap.filterJson.nextTaskForBulk=$(".nextState").val();
                            }
                            if($(".currentState").length>0 && dataSend.filterMap.filterJson &&  $(".currentState").val()!=''){
                                dataSend.filterMap.filterJson.currentTask=$(".currentState").val();
                            }

                            if (!$.isEmptyObject(extraFilterSelected)) {
                                dataSend.filterMap.filterJson[extraFilterSelected.filterId] = extraFilterSelected;
                            }
                            filteredData = dataSend;
                        } else {
                            filteredData = JSON.parse(filteredData);
                        }
                        if (SirionUtils.checkForSearchAndLocalFilters(scope) || SirionUtils.checkForPartialResetFilters(scope)) {
                            var strFilterPost = SirionUtils.updateObjectWithData(JSON.stringify(filteredData, listJson.entityTypeId));
                            filteredData = JSON.parse(strFilterPost);
                        }
                        filteredData = addRemoveSearchTextFromFilterMap(filteredData);
                        let finalFilterDataJson = _.get(filteredData,"filterMap.filterJson") || {},
                            searchNameFilter =  _.get(filteredData,"filterMap.searchName") || null
                        scope && scope.extraFilterData && (finalFilterDataJson[scope.extraFilterData.filterId] = scope.extraFilterData);
                        obj.selectAll = true;
                        delete obj.documentIds;
                        obj.bulkUpdateRequestData = aeService.buildBulkUpdateRequestData(finalFilterDataJson, searchNameFilter, 432);
                    }
                    else {
                        obj['documentIds'] = entityIds;
                    }
                    http.post(endpoint, JSON.stringify(obj)).then(response => {
                        stopLoader();
                        if (response.data.responseCode == "200" && response.data.success) {
                            scope.projectPopupInstance.close();
                            Toaster.create(response.data.response);
                        } else if(response.data.responseCode && response.data.responseCode != "200" && !response.data.success){
                            Toaster.create(response.data.errors[0].message,{iconClass:"icon-Information_filled"});
                        }
                        else {
                            Toaster.create(intl_msg[29007],{iconClass:"icon-Information_filled"});
                        }
                    });
                }
            }

        }
    }
}])

angular.module('ui2.0Directives').directive('projectLanguageModal',['$http','$rootScope','aeService','$location','$timeout',function(http,rootScope,aeService,$location,$timeout){
    return {
        restrict :'AE',
        templateUrl: rootScope.createHtmlUrl("ui2.0/projectLanguage.html"),
        link: function(scope,elm,attrs){
            scope.searchText = {value:""};
            scope.searchCategory = {value:""};
            scope.allChecked = {value:true};
            scope.visibleFields = [];
            scope.sectionInfo = {
                sectionState: {},
                sectionLabels: [
                    {name:"openLanguage", label: intl_msg[26861]},
                ],
                showSectionLabels: {}
            };
            (function () {
                _.forEach(scope.sectionInfo.sectionLabels,obj => {
                    scope.sectionInfo.showSectionLabels[obj.name] = true;
                })
            })();

            scope.selectedLanguages = function() {
                scope.checkedLanguagesList = scope.allLanguages.filter((language) => language.selected);
            };

            scope.toggleSectionState = function(valToToggle){
                scope.sectionInfo.sectionState[valToToggle]= !scope.sectionInfo.sectionState[valToToggle];

                _.forEach(scope.sectionInfo.showSectionLabels,(value,key) => {
                    if(scope.sectionInfo.sectionState[valToToggle]) {
                        if(key != valToToggle) {
                            scope.sectionInfo.showSectionLabels[key] = false;
                        }
                    } else {
                        scope.sectionInfo.showSectionLabels[key] = true;
                    }
                })
            };
            scope.showSection = (label) => label == intl_msg[26861] ? scope.allLanguages.length : false;

            scope.actOnAll = function(flag,type){
                if(type === 'openLanguage'){
                    scope.allChecked.value =flag;
                    scope.visibleFields.map(function(elm){
                        elm.selected=flag;
                        return elm;
                    })
                }
                scope.selectedLanguages();
            };
            scope.toggleField = function(){
                scope.allChecked.value=scope.isAllSelected(scope.visibleFields);
                scope.selectedLanguages();
            };
            scope.searchChanged = function(type){
                if(type === 'openLanguage') {
                    if(!scope.visibleFields.length) {
                        scope.allChecked.value = false;
                        return;
                    }
                    scope.allChecked.value =scope.isAllSelected(scope.visibleFields);
                }
            };

            scope.isAllSelected = function(data){
                var obj = aeService.isAll(data, "selected",true);
                return obj.retval;
            };

            scope.expectedLanguageSubmit = function() {
                startLoader();
                let submitLanguageUrl = addtStamp("/metadataautoextraction/project-languages",true);
                let projectData = {
                    "project": {
                    "id":scope.projectData.id,
                    "name": scope.projectData.name
                    },
                    "languageList": [...scope.checkedLanguagesList]
                };
                let payloadData = {
                    "clientId": window.clientId,
                    "updatedBy": window.currentUserId,
                    ...projectData,
                };
                http.post(submitLanguageUrl, JSON.stringify(payloadData)).then(response => {
                    stopLoader();
                    const {responseCode, success, errors, clientResponse} = response.data || {};
                    if (responseCode == "200" && success) {
                        scope.languagePopupInstance.close();
                        Toaster.create(response.data.response);
                    } else if(responseCode && responseCode != "200" && !success){
                        Toaster.create(errors[0].message,{iconClass:"icon-Information_filled"});
                    }
                    else {
                        Toaster.create(clientResponse,{iconClass:"icon-Information_filled"});
                    }
                }).catch(e => {
                    stopLoader();
                    Toaster.create('Some error occurred',{iconClass:"icon-Information_filled"});
                });
            }

        }
    }
}])
